import {
  SEARCH_INPUT_SUPPLIER_FILTER1_BUYER,
  SEARCH_OPTION_SUPPLIER_FILTER2_BUYER,
  SEARCH_OPTION_SUPPLIER_FILTER3_BUYER,
  SEARCH_OPTION_SUPPLIER_FILTER4_BUYER,
} from './constants'

const initialStateSearchInput = {
  searchSupplierInput: '',
  enterSearchSupplierFilter: null,
}

const initialStateSearchOption2 = {
  searchOptionFilter2: '',
  selectedOptions2: null,
}

const initialStateSearchOption3 = {
  searchOptionFilter3: '',
  selectedOptions3: null,
}

const initialStateSearchOption4 = {
  searchOptionFilter4: '',
  selectedOptions4: null,
}

export const searchInputFilterSupplier = (
  state = initialStateSearchInput,
  action
) => {
  switch (action.type) {
    case SEARCH_INPUT_SUPPLIER_FILTER1_BUYER:
      return {
        ...state,
        searchSupplierInput: action.searchValue,
        enterSearchSupplierFilter: action.enterSearchInputFilter,
      }
    default:
      return state
  }
}
export const searchSelectOptionSupplier2 = (
  state = initialStateSearchOption2,
  action
) => {
  switch (action.type) {
    case SEARCH_OPTION_SUPPLIER_FILTER2_BUYER:
      return {
        ...state,
        searchOptionFilter2: action.searchOption2,
        selectedOptions2: action.selectedOptions2,
      }
    default:
      return state
  }
}

export const searchSelectOptionSupplier3 = (
  state = initialStateSearchOption3,
  action
) => {
  switch (action.type) {
    case SEARCH_OPTION_SUPPLIER_FILTER3_BUYER:
      return {
        ...state,
        searchOptionFilter3: action.searchOption3,
        selectedOptions3: action.selectedOptions3,
      }
    default:
      return state
  }
}

export const searchSelectOptionSupplier4 = (
  state = initialStateSearchOption4,
  action
) => {
  switch (action.type) {
    case SEARCH_OPTION_SUPPLIER_FILTER4_BUYER:
      return {
        ...state,
        searchOptionFilter4: action.searchOption4,
        selectedOptions4: action.selectedOptions4,
      }
    default:
      return state
  }
}
